export function buildLoginRedirectUrl(params) {
  const redirectUrl = window.location.href;
  const url = new URL('https://users.wix.com/signin/signup/password');
  url.searchParams.set('postSignUp', redirectUrl);
  url.searchParams.set('postLogin', redirectUrl);
  url.searchParams.set('forceRender', 'true');
  if (params != null && params.email) {
    url.searchParams.set('defaultEmail', params.email);
  }
  return url.toString();
}
//# sourceMappingURL=auth.js.map